import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"
import { cn } from "../../lib/utils"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      "dsw-z-50 dsw-overflow-hidden dsw-rounded-md dsw-bg-black dsw-text-white dsw-px-3 dsw-py-0 dsw-text-sm dsw-shadow-lg dsw-animate-in dsw-fade-in-0 dsw-zoom-in-95 data-[state=closed]:dsw-animate-out data-[state=closed]:dsw-fade-out-0 data-[state=closed]:dsw-zoom-out-95 data-[side=bottom]:dsw-slide-in-from-top-2 data-[side=left]:dsw-slide-in-from-right-2 data-[side=right]:dsw-slide-in-from-left-2 data-[side=top]:dsw-slide-in-from-bottom-2",
      className
    )}
    {...props}
  />
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } 